module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_5@2x.7de24cf.jpg";